// Styling for the circle settings screen (bead hf-e3b-circle-people-r3z.2).
//
// Design tokens only, and a plain vertical stack of cards. A settings screen is read
// slowly and rarely, so nothing here competes for attention — except the one control
// that changes what everybody else sees, which gets the danger variant and a dialog
// rather than a colour.

export const circleSettingsStylesheet = String.raw`
  .circle-settings {
    display: grid;
    gap: var(--herefor-space-5);
    max-inline-size: 46rem;
  }

  .circle-settings__lede,
  .circle-settings__hint,
  .circle-settings__name,
  .circle-settings__problem-title {
    margin: 0;
  }

  .circle-settings__hint {
    color: var(--herefor-color-ink-muted);
    font-size: var(--herefor-font-size-sm);
  }

  .circle-settings form {
    display: grid;
    gap: var(--herefor-space-3);
    justify-items: start;
  }

  /* Each block's two times sit together, so a boundary is edited as a pair. */
  .circle-settings__block {
    display: grid;
    gap: var(--herefor-space-2);
    inline-size: 100%;
    margin: 0;
    padding: var(--herefor-space-3);
    border: 1px solid var(--herefor-color-border);
    border-radius: var(--herefor-radius-md);
  }

  .circle-settings__problems {
    margin: 0;
    padding-inline-start: var(--herefor-space-5);
    display: grid;
    gap: var(--herefor-space-2);
  }

  .circle-settings__lines {
    display: grid;
    gap: var(--herefor-space-2);
  }

  .circle-settings__lines p {
    margin: 0;
  }

  .circle-settings__problem-title {
    font-weight: var(--herefor-font-weight-semibold);
  }
`;
